export enum OnboardingStep {
	SceneClickAndDrag = 'SceneClickAndDrag',
	LobeAdd = 'LobeAdd',
	LobeClickAndDrag = 'LobeClickAndDrag',
	LobeMultiSelect = 'LobeMultiSelect',
	LobeSnap = 'LobeSnap'
}
